import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AdminAuthService } from 'app/admin/admin-auth.service';
import { OpenAdminDialogYesOrNo } from 'app/admin/admin-yes-or-no/admin-yes-or-no.component';
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'wl-login-otp-dialog',
  templateUrl: './login-otp-dialog.component.html',
  styleUrls: ['./login-otp-dialog.component.css']
})
export class LoginOtpDialogComponent implements OnInit, OnDestroy {

  otpForm: UntypedFormGroup;
  loading = false;
  loadingText = '';
  errorMsg = '';
  resendDisabled = true;
  timer = 30;
  maskedNumber: string = '';
  showMaskedNumber: boolean = false;
  canVerifyOTP: boolean = false;
  otpGenerated: boolean = false;
  otpDigits: string[] = ['', '', '', ''];
  private timerInterval: any;

  constructor(
    private fb: UntypedFormBuilder,
    private adminAuth: AdminAuthService,
    private dialogRef: MatDialogRef<LoginOtpDialogComponent>,
     private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.otpForm = this.fb.group({
      otp: [{ value: '', disabled: true }, Validators.required]
    });

    // this.generateOTP();

      if (this.data && this.data.otpResponse) {

    this.maskedNumber = this.data.otpResponse.maskedMobile;

    this.showMaskedNumber = true;

    this.canVerifyOTP = true;

    this.otpGenerated = true;

    this.otpDigits = ['', '', '', ''];

    this.otpForm.get('otp').enable();

    this.startTimer();
  }

    if (this.data && this.data.errorMsg) {
      this.errorMsg = this.data.errorMsg;
      this.clearOtpFields();
      this.startTimer();
    }
  }

  generateOTP() {
    this.loading = true;
    this.errorMsg = '';

      this.adminAuth.generateUserOtp(this.data.staffId).subscribe(
        res => {
        this.loading = false;          
    if (res && res.success) {
          this.maskedNumber = res.maskedMobile;
          this.showMaskedNumber = true;
          this.canVerifyOTP = true;
          this.otpGenerated = true;
          this.otpDigits = ['', '', '', ''];
          this.otpForm.get('otp').enable();
          this.startTimer();
        } else {
          this.errorMsg = 'Failed to generate OTP. Please go back and try again.';
        }
      },
      err => {
        this.loading = false;

       if (err && err.status === '30_SECONDS_COOLDOWN') {

        this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          disableClose: true,
          data: {
            content1:
              err.message ||
              'Please wait 30 seconds before requesting another OTP.',
            button1Text: 'OK'
          }
        });

        return;
      }

     if (err && err.status === 'OTP_GEN_BLOCKED') {

      this.dialog.open(OpenDialogYesOrNo, {
        width: 'auto',
        height: 'auto',
        disableClose: true,
        data: {
          content1:
            err.message ||
            'OTP generation blocked. Please try again later.',
          button1Text: 'OK'
        }
      });

      this.canVerifyOTP = false;

      this.otpGenerated = false;

      clearInterval(this.timerInterval);

      return;
    }
        this.errorMsg = err.message || 'OTP generation failed. Please go back and try again.';
      }
    );
  }

  verifyOTP() {
    if (!this.otpForm.valid) return;

    const otp = this.otpForm.value.otp;
    clearInterval(this.timerInterval);
    this.dialogRef.close({ status: 'verifying', otp: otp });
  }

  clearOtpFields() {
    this.otpDigits = ['', '', '', ''];
    this.otpForm.get('otp').setValue('');
  }

  get allDigitsFilled(): boolean {
    return this.otpDigits.every(d => d !== '');
  }

  onOtpInput(index: number, event: any, nextEl: HTMLInputElement) {
    const digit = event.target.value.replace(/\D/g, '').slice(-1);
    event.target.value = digit;
    const updated = [...this.otpDigits];
    updated[index] = digit;
    this.otpDigits = updated;
    if (digit && nextEl) { nextEl.focus(); }
    this.otpForm.get('otp').setValue(this.otpDigits.join(''));
  }

  onOtpKeydown(index: number, event: KeyboardEvent, prevEl: HTMLInputElement) {
    if (event.key === 'Backspace' && !this.otpDigits[index] && prevEl) {
      prevEl.focus();
    }
  }

  startTimer() {
    clearInterval(this.timerInterval);
    this.resendDisabled = true;
    this.timer = 30;

    this.timerInterval = setInterval(() => {
      this.timer--;
      if (this.timer === 0) {
        clearInterval(this.timerInterval);
        this.resendDisabled = false;
      }
    }, 1000);
  }

  resendOTP() {
    if (this.resendDisabled) return;
    clearInterval(this.timerInterval);
    this.dialogRef.close({ status: 'resend' });
  }

  cancelLogin() {
    clearInterval(this.timerInterval);
    this.dialogRef.close('cancelled');
  }

  ngOnDestroy() {
    clearInterval(this.timerInterval);
  }
}
